<template>
    <div >
        <v-container fluid grid-list-xl>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card  v-if="visible" style="min-width: 50vw; padding: 32px">
                        <v-card-title>
                            <div primary-title>
                                <h3 class="headline mb-0">Recibo <b>{{id}}</b></h3>
                                <br>
                                <div>Suba aquí el recibo del banco después de realizar la transferencia. Tras subir el archivo se enviará un correo de confirmación a <b>{{form ? form.email: ''}}</b>{{form ? '' : 'su correo'}}</div>
                            </div>
                        </v-card-title>
                        <v-container fluid grid-list-xl>
                            <v-layout row wrap>
                                <v-flex  xs12 md12>
                                    <file-input v-model="file"></file-input>
                                </v-flex>
                            </v-layout>
                            <v-alert
                                    outline
                                    type="error"
                                    :value="error"
                                    transition="scale-transition"
                            >
                                Ha ocurrido un error, contacta con inscripcionesverano@scouts284.org.in
                            </v-alert>
                        </v-container>
                    </v-card>
                    <v-alert
                            outline
                            type="success"
                            :value="!visible"
                            transition="scale-transition"
                    >
                        Se ha enviado el recibo con éxito, revisaremos los datos y en las próximas 48h recibirá un correo de confirmación
                    </v-alert>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import FileInput from "./formulario/FileInput";

    export default {
        components: {FileInput},
        props: ['id'],
        data: () => ({
           file: null,
           form: null,
           visible: true,
            error: false
        }),
        name: "inscripciones-recibo",
        firestore () {
            return {
                form: this.$db.collection('forms').doc('inscripciones').collection('answers').doc(this.id)
            }
        },
        watch: {
            file(val) {
                if(val) {
                    var vue = this
                    this.$db.collection('forms').doc('inscripciones').collection('answers').doc(this.id).update({
                        recipe: val[0]
                    }).then(function () {
                        vue.visible = false
                    }).catch(function (error) {
                        vue.error = true
                            console.error("Error writing document: ", error);
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>